<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use></svg>
  Inviter til OK-app
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <form [formGroup]="userFormGroup" (ngSubmit)="save()">
    <div class="form-row">
      <mat-form-field>
        <mat-label>ID</mat-label>
        <input matInput placeholder="ID for brugeren" maxlength="100" formControlName="alias" />
        @if (userFormGroup.controls.alias.invalid && userFormGroup.controls.alias.hasError('maxlength')) {
          <span>
            <mat-error> ID må maksimalt være 100 tegn </mat-error>
            <mat-error> ID må maksimalt være 100 tegn </mat-error>
          </span>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <div class="grid-cols">
        <adm-country-code-selector [formItem]="userFormGroup.controls.phoneCountryCode" />
        <adm-phone-number-input
          [label]="'Mobilnummer'"
          [formItem]="userFormGroup.controls.phoneNumber"
          [countryCode]="userFormGroup.controls.phoneCountryCode" />
      </div>
    </div>
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Vælg adgangsgrupper</mat-label>
        <mat-select required [formControl]="userFormGroup.controls.selectedAccessGroups" multiple okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ userFormGroup.controls.selectedAccessGroups.value[0]?.name || '' }}
            @if (userFormGroup.controls.selectedAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ userFormGroup.controls.selectedAccessGroups.value.length - 1 }}
                {{ userFormGroup.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups$ | async; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>

    <mat-dialog-actions>
      <button type="button" mat-stroked-button mat-dialog-close>Annuller</button>
      <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="userFormGroup.invalid">
        Send invitation
      </button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
